import { copy as chineseCopy } from "./zh-CN.js";
import { copy as englishCopy, pageCopy } from "./en.js";

const storageKey = "lusion-clone-language";
export function resolveLocale(search, saved) {
  const requested = new URLSearchParams(search).get("lang");
  const normalize = (value) =>
    value === "en" ? "en" : ["zh", "zh-CN"].includes(value) ? "zh-CN" : null;
  return normalize(requested) || normalize(saved) || "zh-CN";
}
let saved;
try {
  if (typeof window !== "undefined")
    saved = window.localStorage.getItem(storageKey);
} catch {
  /* 隐私模式仍可使用 URL 切换。 */
}
export const locale = resolveLocale(
  typeof location === "undefined" ? "" : location.search,
  saved,
);
export const copy = locale === "en" ? englishCopy : chineseCopy;

export function initializeLocale() {
  document.documentElement.lang = locale;
  try {
    localStorage.setItem(storageKey, locale);
  } catch {
    /* URL 保留当前选择。 */
  }
  if (locale === "en") {
    const translate = (value) => {
      const key = value.trim().replace(/\s+/g, " ");
      return Object.hasOwn(pageCopy, key)
        ? value.replace(value.trim(), pageCopy[key])
        : value;
    };
    const walker = document.createTreeWalker(
      document.documentElement,
      NodeFilter.SHOW_TEXT,
    );
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.parentElement.closest("script, style"))
        node.nodeValue = translate(node.nodeValue);
    }
    for (const element of document.querySelectorAll(
      "[content], [aria-label], [placeholder], [title], [alt]",
    )) {
      for (const attr of [
        "content",
        "aria-label",
        "placeholder",
        "title",
        "alt",
      ]) {
        if (element.hasAttribute(attr))
          element.setAttribute(attr, translate(element.getAttribute(attr)));
      }
    }
  }
  document.querySelector('meta[property="og:locale"]').content =
    locale === "en" ? "en_US" : "zh_CN";
  const button = document.getElementById("language-switch");
  button.textContent = locale === "en" ? "中文" : "EN";
  button.lang = locale === "en" ? "zh-CN" : "en";
  button.setAttribute(
    "aria-label",
    locale === "en" ? "Switch to Chinese" : "切换到英文",
  );
  button.addEventListener("click", () => {
    const next = locale === "en" ? "zh-CN" : "en";
    try {
      localStorage.setItem(storageKey, next);
    } catch {
      /* URL 保留当前选择。 */
    }
    const url = new URL(location.href);
    url.searchParams.set("lang", next);
    location.assign(url.href);
  });
}
